import { forwardRef, type Ref, type SVGProps } from "react";
const IconSchoolFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M30 29a1 1 0 0 1-1 1H5a3 3 0 0 1-3-3v-4a3 3 0 0 1 3-3h7.47C10.28 18 9 13.45 9 12a4.83 4.83 0 0 1 4.94-5 4.76 4.76 0 0 1 2.06.48V7a2.91 2.91 0 0 1 3-3 1 1 0 0 1 0 2 .92.92 0 0 0-1 1v.48A4.76 4.76 0 0 1 20.06 7 4.83 4.83 0 0 1 25 12c0 1.45-1.28 6-3.47 8H29a1 1 0 0 1 0 2h-1v2H6a1 1 0 0 0 0 2h22v2h1a1 1 0 0 1 1 1"
    />
  </svg>
);
const ForwardRef = forwardRef(IconSchoolFilledSVG);
ForwardRef.displayName = "IconSchoolFilled";
export { ForwardRef as IconSchoolFilled };
